import React, { useEffect } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";

import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./views/Home";
import Profile from "./views/Profile";
import Organisations from "./views/Organisations";
import CreateOrganisation from "./views/CreateOrganisation";
import OrganisationDetails from "./views/OrganisationDetails";
import OrganisationEdit from "./views/OrganisationEdit";
import OrganisationMembers from "./views/OrganisationMembers";
import OrganisationOffers from "./views/OrganisationOffers";
import Upload from "./views/Upload";
import Embed from "./views/Embed";
import UserStringCapture from "./components/UserStringCapture";
import { useAuth0 } from "@auth0/auth0-react";
import history from "./utils/history";

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

const App = () => {
  const { isLoading, error, isAuthenticated, getAccessTokenSilently, loginWithPopup, loginWithRedirect } = useAuth0();

  // Use only SPA JS authentication - no Universal Login redirects
  useEffect(() => {
    console.log('App: Authentication state changed:', { isLoading, isAuthenticated, error });
    
    if (!isLoading && !isAuthenticated) {
      console.log('App: Attempting silent authentication...');
      // Try silent authentication - this happens entirely on your domain
      getAccessTokenSilently({ ignoreCache: false })
        .then((token) => {
          console.log('App: Silent authentication succeeded, token length:', token?.length);
        })
        .catch((error) => {
          console.log('App: Silent authentication failed:', error);
          // Note: postMessage is now handled by UserStringCapture component via shared service
        });
    }
  }, [isLoading, isAuthenticated, getAccessTokenSilently]);

  if (error) {
    console.log('App: Auth error:', error);
    return <div>Oops... {error.message}</div>;
  }

  return (
    <Router history={history}>
      <Switch>
        {/* Embed route - always render UserStringCapture to keep timer running */}
        <Route path="/embed" render={() => (
          <UserStringCapture isAuthenticated={isAuthenticated} />
        )} />
        
        {/* All other routes require authentication */}
        <Route path="*">
          {isLoading || !isAuthenticated ? (
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
              <div className="text-center" style={{ maxWidth: '600px', padding: '2rem' }}>
                <img 
                  className="mb-4" 
                  src={`${process.env.PUBLIC_URL || ''}/wideby-logo.png`} 
                  alt="Wideby Logo" 
                  style={{ width: '300px', height: 'auto', maxWidth: '100%' }}
                />
                <h1 className="mb-4" style={{ color: '#343a40', fontWeight: '600' }}>Wideby</h1>
                <p className="lead mb-5" style={{ color: '#6c757d', maxWidth: '500px', margin: '0 auto 2rem auto' }}>
                  Find and book local deals and services near you. Quick and easy.
                </p>
                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center mb-4">
                  <button 
                    className="btn btn-primary btn-lg px-4 py-2"
                    onClick={() => {
                      console.log('App: Login popup clicked');
                      loginWithPopup();
                    }}
                    style={{ minWidth: '160px' }}
                  >
                    Login
                  </button>
                  {/* <button 
                    className="btn btn-outline-primary btn-lg px-4 py-2"
                    onClick={() => {
                      console.log('App: Login redirect clicked');
                      loginWithRedirect();
                    }}
                    style={{ minWidth: '160px' }}
                  >
                    Login with Redirect
                  </button> */}
                </div>
              </div>
            </div>
          ) : (
            <div id="app" className="d-flex flex-column h-100">
              <NavBar />
              <Container className="flex-grow-1 mt-5">
                <Switch>
                  <Route path="/" exact component={Home} />
                  <Route path="/profile" component={Profile} />
                  <Route path="/organisations" exact component={Organisations} />
                  <Route path="/organisations/create" component={CreateOrganisation} />
                  <Route path="/organisations/:id/edit" component={OrganisationEdit} />
                  <Route path="/organisations/:id/members" component={OrganisationMembers} />
                  <Route path="/organisations/:id/offers" component={OrganisationOffers} />
                  <Route path="/organisations/:id" component={OrganisationDetails} />
                  <Route path="/upload/:uploadType" component={Upload} />
                </Switch>
              </Container>
              <Footer />
            </div>
          )}
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
